import React from "react";
import { useArtistDisplayName } from "@/api/hooks/useArtistDisplayName";
import MaskExactProfessionalName from "./MaskExactProfessionalName";

interface ArtistPreviewTagsProps {
  maskDisplayName?: boolean;
}

const ArtistPreviewTags = ({ maskDisplayName = false }: ArtistPreviewTagsProps) => {
  const displayName = useArtistDisplayName();
  const textArray = [
    {
      id: 1,
      name: "Book Anchor/Emcee in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 2,
      name: "Book ANCHOR/EMCEE for Campus Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 3,
      name: "Book ANCHOR/EMCEE for Charity Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 4,
      name: "Book ANCHOR/EMCEE for Concert/Festival Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 5,
      name: "Book ANCHOR/EMCEE for Corporate Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 6,
      name: "Book ANCHOR/EMCEE for Exhibition Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 7,
      name: "Book ANCHOR/EMCEE for Fashion Show Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 8,
      name: "Book ANCHOR/EMCEE for Inauguration Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 9,
      name: "Book ANCHOR/EMCEE for Private Party Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 10,
      name: "Book ANCHOR/EMCEE for Professional Hiring Event in delhi",
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 11,
      name: "Book ANCHOR/EMCEE for Wedding Event in delhi",
      slug: "book-anchor-online/l--delhi_e--wedding",
    },
    {
      id: 12,
      name: "Book ANCHOR/EMCEE for Virtual Event in delhi",
      slug: "book-anchor-online/l--delhi_e--virtual",
    },
    {
      id: 13,
      name: `Hire ${displayName} for Campus`,
      slug: "book-anchor-online/l--delhi_e--campus",
    },
    {
      id: 14,
      name: `Hire ${displayName} for Charity`,
      slug: "book-anchor-online/l--delhi_e--charity",
    },
    {
      id: 15,
      name: `Hire ${displayName} for Concert/Festival`,
      slug: "book-anchor-online/l--delhi_e--concert-festival",
    },
    {
      id: 16,
      name: `Hire ${displayName} for Corporate`,
      slug: "book-anchor-online/l--delhi_e--corporate",
    },
    {
      id: 17,
      name: `Hire ${displayName} for Exhibition`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 18,
      name: `Hire ${displayName} for Fashion Show`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 19,
      name: `Hire ${displayName} for Inauguration`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 20,
      name: `Hire ${displayName} for Private Party`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 21,
      name: `Hire ${displayName} for Professional Hiring`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 22,
      name: `Hire ${displayName} for Wedding`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 23,
      name: `Hire ${displayName} for Virtual`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 24,
      name: `Book ${displayName} for Campus`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 25,
      name: `Book ${displayName} for Charity`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 26,
      name: `Book ${displayName} for Concert/Festival`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 27,
      name: `Book ${displayName} for Corporate`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 28,
      name: `Book ${displayName} for Exhibition`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 29,
      name: `Book ${displayName} for Fashion Show`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 30,
      name: `Book ${displayName} for Inauguration`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 31,
      name: `Book ${displayName} for Private Party`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 32,
      name: `Book ${displayName} for Professional Hiring`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 33,
      name: `Book ${displayName} for Wedding`,
      slug: "book-anchor-online/l--delhi",
    },
    {
      id: 34,
      name: `Book ${displayName} for Virtual`,
      slug: "book-anchor-online/l--delhi",
    },
  ];

  return (
    <div className=" w-screen">
      {textArray !== null && (
        <div className=" mx-auto bg-black shadow-2xl shadow-pink-900 border-t-4 border-pink-900  relative mb-10 md:mb-[250px] flex flex-col justify-center items-center px-10 max-md:px-4 py-4">
          <div className="flex flex-col items-center">
            <p
              className="text-[32px] leading-[38.73px] font-[300] text-white pt-8"
              style={{ opacity: "0.6" }}
            >
              Related Tags
            </p>
          </div>
          <div className="overflow-hidden py-10">
            <div className="flex flex-row flex-wrap gap-1 w-full pointer-events-none">
              {textArray.map((tag) => (
                <span
                  key={tag.id}
                  className="text-white text-start text-xs border-r-1 border-gray-500 h-5 px-2 last:border-none cursor-default"
                >
                  {maskDisplayName &&
                  tag.name.trim().length > 0 ? (
                    <MaskExactProfessionalName value={tag.name} />
                  ) : (
                    tag.name
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArtistPreviewTags;
